var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import "whatwg-fetch";
import { Button } from "@components/ui";
import { PROPERTY_SHIPPING_COUNTRY, PROPERTY_SHIPPING_PLACE, PROPERTY_SHIPPING_SLOT, PROPERTY_SHIPPING_TYPE, PROPERTY_SHIPPING_ZIP_CODE, SHIPPING_PLACE, SHIPPING_SLOT, SHIPPING_TYPE, } from "@constants/index";
import { useStore } from "@context/store";
import { useUpdateSubscription } from "@hooks/recharge";
import { useEffect, useState } from "react";
import { useConfig } from "@context/config";
import { DeliveryType } from "@schema/types";
var Recharge = function () {
    var _a = useConfig(), recharge = _a.recharge, country = _a.country;
    var _b = useStore(), timeEntry = _b.timeEntry, location = _b.location, type = _b.type, address = _b.address;
    var _c = useState(false), changed = _c[0], setChanged = _c[1];
    var _d = useUpdateSubscription(), updateSubscription = _d[0], _e = _d[1], data = _e.data, error = _e.error, loading = _e.loading;
    var handleUpdate = function () {
        var _a;
        if (type !== null && location && timeEntry) {
            updateSubscription((_a = {
                    shopify_variant_id: timeEntry.variantId
                },
                _a[PROPERTY_SHIPPING_TYPE] = type,
                _a[PROPERTY_SHIPPING_PLACE] = location.id,
                _a[PROPERTY_SHIPPING_SLOT] = timeEntry.id,
                _a[PROPERTY_SHIPPING_COUNTRY] = country,
                _a[PROPERTY_SHIPPING_ZIP_CODE] = type === DeliveryType.Doorstep
                    ? location.zipCode
                    : "",
                _a), address);
        }
    };
    useEffect(function () {
        if (recharge) {
            var _a = recharge, initialAddress = _a.address, _b = _a.properties, _c = SHIPPING_PLACE, place = _b[_c], _d = SHIPPING_TYPE, deliveryType = _b[_d], _e = SHIPPING_SLOT, slot = _b[_e];
            if (type !== null && location && timeEntry) {
                if (!(deliveryType === type &&
                    location.id === place &&
                    timeEntry.id === slot &&
                    initialAddress &&
                    address &&
                    JSON.stringify(initialAddress) ===
                        JSON.stringify(address))) {
                    setChanged(true);
                    return;
                }
            }
        }
        setChanged(false);
    }, [timeEntry, location, type]);
    useEffect(function () {
        if (data) {
            window.location.reload();
        }
    }, [data]);
    return (_jsxs(_Fragment, { children: [error && _jsx("p", { children: "Oops. Unable to update subscription. Try again." }, void 0),
            _jsx(Button, __assign({ className: "px-8 py-3", primary: true, onClick: handleUpdate, disabled: !changed }, { children: loading ? "Updating" : "Save" }), void 0)] }, void 0));
};
export default Recharge;
